import React from "react"
import { useContent } from "@thoughtbot/superglue"

import { DeveloperDocsLayout, type DeveloperDocsPage } from "@javascript/components/developer-docs/DeveloperDocsLayout"
import { ContentAndFormsPage } from "@javascript/components/developer-docs/ContentAndFormsPage"

interface ContentAndFormsContent {
  pages: DeveloperDocsPage[]
}

export default function ContentAndForms() {
  const { pages } = useContent<ContentAndFormsContent>()

  return (
    <DeveloperDocsLayout pages={pages} currentHref="/developers/content-and-forms">
      <ContentAndFormsPage />
    </DeveloperDocsLayout>
  )
}
